import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7440644b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row no-gutters position-relative" }
const _hoisted_2 = { class: "pointer" }
const _hoisted_3 = ["src", "onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons text-dark" }, "keyboard_arrow_left", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons text-dark" }, "keyboard_arrow_right", -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: slide.id,
        class: _normalizeClass(["col-2 position-relative thumbnail", (index >= _ctx.start && index <= _ctx.end)? '' : 'd-none'])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            alt: "Thumb",
            class: "w-100 position-absolute",
            src: slide.src,
            onClick: ($event: any) => (_ctx.updatePhoto(slide.src))
          }, null, 8, _hoisted_3)
        ])
      ], 2))
    }), 128)),
    (this.start > 0)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.prev())),
          class: "d-flex p-1 pointer position-absolute prev"
        }, _hoisted_5))
      : _createCommentVNode("", true),
    (this.end < this.slides.length - 1)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.next())),
          class: "d-flex p-1 pointer position-absolute next"
        }, _hoisted_7))
      : _createCommentVNode("", true)
  ]))
}